import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth/auth.service';
import { CONFIG } from './config';
import { PermissionsService } from './permissions.service';
/*
* Deprecated: Class-based Route guards are deprecated in favor of functional guards. An injectable class can * be used as a functional guard using the inject function: canActivate: [() => inject(myGuard).canActivate()]
*/
@Injectable({ providedIn: 'root' })
export class AuthorizationGuardService {
  constructor(private router: Router, private authService: AuthService,
    private permissions: PermissionsService) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.isAuthenticated(state)) {
      return false;
    }
    if (this.permissions.routeHasPermission(route)) {
      return true;
    }
    return this.sendBackToOrigin();
  }

  public canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.isAuthenticated(state)) {
      return false;
    }

    if (this.authService.authenticated && this.permissions.routeHasPermission(route)) {
      return true;
    }

    return this.sendBackToOrigin();
  }

  public isAuthenticated(state: RouterStateSnapshot) {
    const authenticated = this.authService.authenticated;

    if (!authenticated) {
      this.authService.clearLoginSession();
      this.router.navigate([CONFIG.routes.authLogin], { queryParams: { returnUrl: state.url } });

      return false;
    }

    return true;
  }

  public sendBackToOrigin() {
    if (location.hash) {
      this.router.navigate([location.hash.split('#')[0]]);
    } else {
      this.router.navigate([this.authService.urlCatalog + CONFIG.routes.dashboard]);
    }

    return false;
  }



}

export const AuthorizationGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => inject(AuthorizationGuardService).canActivate(next, state);


